import DisbursementReport from "../../../jsx/components/Dashboard/DisbursementReport/DisbursementReport";

const DisbursementReportsWrapper = () => {
  return <DisbursementReport />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(DisbursementReportsWrapper);
